import { useState } from 'react'

import { type Scope, createContextScope } from '@radix-ui/react-context'
import {
  InputCounterDecrement,
  InputCounterIncrement,
} from './components/input-counter-button'
import { InputCounterControl } from './components/input-counter-control'
import { InputCounterHelperText } from './components/input-counter-helpertext'
import { InputCounterInput } from './components/input-counter-input'
import { InputCounterLabel } from './components/input-counter-label'
import { InputCounterRootVariants } from './input-counter.styles'
import type {
  InputCounterContext,
  InputCounterScopedProps,
  TInputCounterProps,
} from './input-counter.types'

const DISPLAY_NAME = 'InputCounterRoot'

const InputCounterRoot = (
  props: InputCounterScopedProps<TInputCounterProps>
) => {
  const {
    size = 'ml',
    children,
    value,
    onValueChange,
    disabled,
    hasError,
    readOnly,
    __scopeInputCounter,
  } = props
  const [currentValue, setCurrentValue] = useState(value ?? 0)

  const componentsProps = {
    size: size,
    scope: __scopeInputCounter,
    setCurrentValue,
    currentValue,
    value,
    onValueChange,
    disabled,
    readOnly,
    hasError,
  }

  return (
    <InputCounterProvider {...componentsProps}>
      <div className={InputCounterRootVariants({})}>{children}</div>
    </InputCounterProvider>
  )
}

InputCounterRoot.displayName = DISPLAY_NAME

/*
----------------------------------------------------------------
Scope Definition
----------------------------------------------------------------
*/

const [createInputCounterContext] = createContextScope(DISPLAY_NAME)

export const [InputCounterProvider, useInputCounterContext]: readonly [
  ProviderType<InputCounterContext>,
  (consumerName: string, scope: Scope) => InputCounterContext,
] = createInputCounterContext<InputCounterContext>(DISPLAY_NAME)

/*
----------------------------------------------------------------
Composition Export
----------------------------------------------------------------
*/

export const InputCounter = {
  Root: InputCounterRoot,
  Decrement: InputCounterDecrement,
  Increment: InputCounterIncrement,
  Control: InputCounterControl,
  Input: InputCounterInput,
  Label: InputCounterLabel,
  HelperText: InputCounterHelperText,
}
